/** Adapt stored/config filters to the shared SSR and client backend mapper. */
import {
  emptyParsedSearchParams,
  normalizeFilterParams,
  type ParsedSearchParams,
} from '@/lib/search-filters';

export function filterParamsToParsed(raw: unknown): ParsedSearchParams {
  return { ...emptyParsedSearchParams(), ...normalizeFilterParams(raw) };
}
